import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

const axios = require('axios').default;
import ToDoTaskCompletion from './ToDoTaskCompletion';
import InfiniteScroll from 'react-infinite-scroll-component';

import {
  ALL_TASKS,
  ARCHIVED_TASKS,
  CURRENT_PARTNERSHIP_TASKS
} from '../constants/dashboardConstants';

const Tasks = ({
  currentEvent,
  currentPartnership,
  csrfToken,
  taskCompletionLabel,
  taskMenuState,
  taskMenuStateChanged
}) => {
  const [sentFirstFetch, setSentFirstFetch] = useState(false);
  const [taskCompletions, setTaskCompletions] = useState([]);
  const [hasMore, setHasMore] = useState(false);
  const [nextPage, setNextPage] = useState(1);
  const [counts, setCounts] = useState({active: 0, assigned_to_me: 0, archived: 0});

  const fetchTaskCompletions = (reset = false) => {
    if(reset) {
      setSentFirstFetch(false);
      setTaskCompletions([]);
      setHasMore(false);
      setNextPage(1);
    }

    let status = "active";

    if(taskMenuState === ALL_TASKS) {
      status = "active";
    } else if(taskMenuState === CURRENT_PARTNERSHIP_TASKS) {
      status = "assigned_to_me";
    } else if(taskMenuState === ARCHIVED_TASKS) {
      status = "archived";
    }

    return axios.get("/e/" + currentEvent.permalink + "/p/" + currentPartnership.id + "/task_completions", {
        params: {
          page: (reset ? 1 : nextPage),
          status: status
        }
      })
      .then(({ data }) => {
        setCounts(data.counts);

        setSentFirstFetch(true);
        setTaskCompletions((prevTaskCompletions) => [...prevTaskCompletions, ...data.collection]);
        setHasMore(data.collection.length === 30);
        setNextPage(data.current_page + 1);
      });
  };

  useEffect(() => {
    fetchTaskCompletions(true);
  }, [taskMenuState]);

  return (
    <div className="card border-0 shadow-1">
      <div className="card-header"
            style={{
              "borderBottom": "1px solid #e8e8e8",
              "background": "white"
            }}>
        <div className='row'>
          <div className='col-xs-auto'
                style={{"paddingLeft": "15px"}}>
            <p className="mb-0"
                style={{"fontSize": "18px"}}>
              <strong>Tasks</strong>
            </p>
          </div>
          <div className='col d-flex align-items-center justify-content-end small'>
            <ul className='list-group list-group-horizontal'>
              {(counts.assigned_to_me > 0 || counts.archived > 0) && (
                <li className='list-group-item border-0 py-0 pl-0 pr-3'>
                  <a href="#"
                      onClick={
                        (e) => {
                          e.preventDefault();
                          taskMenuStateChanged(ALL_TASKS);
                        }
                      }
                      className={taskMenuState === ALL_TASKS ? 'text-dark' : 'text-muted'}>
                    View All <strong>{counts.active}</strong> Tasks
                  </a>
                </li>
              )}
              {counts.assigned_to_me > 0 && (
                <li className='list-group-item border-0 py-0 pl-0 pr-3'>
                  <a href="#"
                      onClick={
                        (e) => {
                          e.preventDefault();
                          taskMenuStateChanged(CURRENT_PARTNERSHIP_TASKS);
                        }
                      }
                      className={taskMenuState === CURRENT_PARTNERSHIP_TASKS ? 'text-dark' : 'text-muted'}>
                    <strong>{counts.assigned_to_me}</strong> Assigned to {currentPartnership.name}
                  </a>
                </li>
              )}
              {counts.archived > 0 && (
                <li className='list-group-item border-0 py-0 pl-0 pr-0'>
                  <a href="#"
                    onClick={
                      (e) => {
                        e.preventDefault();
                        taskMenuStateChanged(ARCHIVED_TASKS);
                      }
                    }
                    className={taskMenuState === ARCHIVED_TASKS ? 'text-dark' : 'text-muted'}>
                  <strong>{counts.archived}</strong> Archived
                  </a>
                </li>
              )}
            </ul>
          </div>
        </div>
      </div>
      <div className="card-body" style={{paddingRight: "0px", paddingLeft: "0px"}}>
        <InfiniteScroll dataLength={taskCompletions.length}
                        next={fetchTaskCompletions}
                        hasMore={hasMore}
                        style={{ overflowX: "hidden" }}
                        scrollableTarget="body-element"
                        loader={
                          <div className="text-center my-2">
                            <img src="/images/loading.gif" style={{width: "16px"}} />
                          </div>
                        }>
          {taskCompletions.map((taskCompletion, index) =>
            <ToDoTaskCompletion key={index}
                                  isLast={false}
                                  currentEvent={currentEvent}
                                  currentPartnership={currentPartnership}
                                  taskCompletion={taskCompletion}
                                  csrfToken={csrfToken}
                                  taskCompletionLabel={taskCompletionLabel} />
          )}
        </InfiniteScroll>
        {taskCompletions.length === 0 && sentFirstFetch ? (
          <div className="card-body">
            <div className='row'>
              <div className='col text-center my-3'>
                <i className="fad fa-check-circle mb-2 text-success"
                  style={{"fontSize": "55px"}}></i>
                <p className="mb-0 text-dark"
                  style={{"fontSize": "16px"}}>
                  <strong>You're all caught up!</strong>
                </p>
                <p className="mb-0 text-muted"
                  style={{"fontSize": "14px"}}>
                  You have no assignments to complete.
                </p>
              </div>
            </div>
          </div>
        ) : null}
      </div>
    </div>
  )
};

Tasks.propTypes = {
  currentEvent: PropTypes.object.isRequired,
  currentPartnership: PropTypes.object.isRequired,
  pendingTaskCompletions: PropTypes.array,
  csrfToken: PropTypes.string.isRequired,
  taskCompletionLabel: PropTypes.func.isRequired,
  completedTaskCompletions: PropTypes.array,
  unarchivedTaskCompletions: PropTypes.array,
  currentPartnershipTaskCompletions: PropTypes.array,
  archivedTaskCompletions: PropTypes.array,
  taskMenuState: PropTypes.string,
  taskMenuStateChanged: PropTypes.func.isRequired
};

export default Tasks;
